@if (initialized) {
  <div>
    <!-- Labor -->
    <div class="mat-body-strong">{{reportEquipment.quantity}} {{reportEquipment.type}} <!-- (Jerdon, 11 hours) --></div>
    @if (reportEquipment.comment) {
      <div class="mat-caption">{{reportEquipment.comment}}</div>
    }
    <!-- /Labor -->
  </div>
}
